import { MutableRefObject, useEffect, useRef, useState } from "react";
import { IBufferStartProps } from "./Models";
import { TOTAL_TILE_COLUMN } from "./BufferStart";
import BufferTimeHover from "@/assets/icons/attendees/bufferTimeHover.svg";
import useImage from "use-image";
import { Rect } from "react-konva";
import { Html } from "react-konva-utils";

export const BufferEnd = ({
  stroke,
  x,
  totalTile,
  widthState,
  heightState,
  height,
  postBufferTime,
  bufferTimeText,
  minutesText,
  image,
  isSelected,
  isHover,
}: IBufferStartProps) => {
  const timeTooltip_end =
    bufferTimeText + ": " + postBufferTime + " " + minutesText;

  const [tooltipVisible_end, setTooltipVisible_end] = useState(false);
  const [tooltipPosition_end, setTooltipPosition_end] = useState({
    x: 0,
    y: 0,
  });
  const [widthElement_end, setWidthElement_end] = useState<number>(0);

  const rectRef: MutableRefObject<any> = useRef(null);

  useEffect(() => {
    if (isHover) {
      rectRef?.current?.zIndex(9999); // Đặt giá trị zIndex cao nhất
      rectRef?.current?.moveToTop();
      rectRef.current.getLayer().batchDraw();
    } else if (!isHover) {
      rectRef?.current?.zIndex(0);
      rectRef?.current?.moveDown();
      rectRef.current.getLayer().batchDraw();
    }
  }, [isHover]);

  const handleMouseEnter = (e: any) => {
    const { x, y } = e.target.getStage().getPointerPosition();
    if (e.target.getStage()?.attrs?.width) {
      setWidthElement_end(e.target.getStage().attrs.width);
    }
    const position = {
      x: x,
      y: y - 60,
    };
    setTooltipVisible_end(true);
    setTooltipPosition_end(position);
  };

  const handleMouseLeave = () => {
    setTooltipVisible_end(false);
  };

  const positionTooltip = (): React.CSSProperties => {
    if (tooltipPosition_end.x > widthElement_end / 2) {
      return {
        right: widthElement_end - tooltipPosition_end.x,
      };
    }
    return {
      left: tooltipPosition_end.x,
    };
  };

  // let _with = (totalTile * widthState) / TOTAL_TILE_COLUMN / totalTile / 2;
  const oneHour = (widthState / TOTAL_TILE_COLUMN) * 2;
  const _with: number = ((postBufferTime || 0) * oneHour) / 60;

  const [image2] = useImage(BufferTimeHover);

  return (
    <>
      <Rect
        ref={rectRef}
        x={x + (totalTile * widthState) / TOTAL_TILE_COLUMN}
        y={isSelected ? heightState - height + 3.1 : heightState - height + 4}
        height={isSelected ? height + 2 : height - 1}
        width={_with || 0}
        stroke={isHover ? "rgba(87, 127, 180, 1)" : stroke}
        // strokeWidth={strokeWidth}
        fillPatternImage={isHover ? image2 : image}
        onMouseEnter={isSelected ? handleMouseEnter : () => {}}
        onMouseLeave={isSelected ? handleMouseLeave : () => {}}
        cornerRadius={isSelected ? 3 : 0}
      />

      <Html
        divProps={{
          style: {
            position: "relative",
          },
        }}
      >
        {tooltipVisible_end && (
          <div
            style={{
              position: "absolute",
              top: tooltipPosition_end.y,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              padding: "2px",
              borderRadius: "3px",
              fontSize: "11px",
              zIndex: 9999,
              ...positionTooltip(),
            }}
          >
            {timeTooltip_end}
          </div>
        )}
      </Html>
    </>
  );
};
